
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/guides/content-security-policy",
      function () {
        return require("private-next-pages/material-ui/guides/content-security-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/guides/content-security-policy"])
      });
    }
  